import Cookies from 'js-cookie';

// getIdToken, regresa una promesa para estar listos cuando se tenga un refresh token
export const getIdToken = () => {
  return Promise.resolve(
    Cookies.get(`${process.env.REACT_APP_COOKIE_CONSTANT}`)
  );
};

export const getJwtToken = tokenFunction => {
  return Promise.resolve(
    Cookies.get(`${process.env.REACT_APP_COOKIE_CONSTANT}`)
  ).then(jwtToken => {
    tokenFunction(jwtToken);
  });
};

// utilidad para generar un bearer
export const getAuthHeader = jwtCookie => {
  if (jwtCookie) {
    return {
      Authorization: jwtCookie ? `Bearer ${jwtCookie}` : 'Bearer *'
    };
  }
  let jwt = Cookies.get(`${process.env.REACT_APP_COOKIE_CONSTANT}`);
  return { Authorization: jwt ? `Bearer ${jwt}` : 'Bearer *' };
};

// Set Cookie
export const setCookie = jwtCookie => {
  if (jwtCookie) {
    const cookieOptions = {
      secure: false,
      expires: 1000 * 60 * 60 * 24 * 5,
      domain: '.mayahii.com',
      path: '/',
      sameSite: true
    };

    Cookies.set(
      `${process.env.REACT_APP_COOKIE_CONSTANT}`,
      jwtCookie,
      cookieOptions
    );
  }
  let jwt = Cookies.get(`${process.env.REACT_APP_COOKIE_CONSTANT}`);
  return jwt;
};

// Remove Cookie
export const removeCookieSession = () => {
  Cookies.remove(`${process.env.REACT_APP_COOKIE_CONSTANT}`, {
    path: '/',
    domain: '.mayahii.com'
  });
  const url = window.location.pathname.split('/');
  window.location.href = `/${url[1]}`;
  // return true;
};
